import { Injectable } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { ModalOptions } from '../models';

/**
 * An internal service allowing to access, from the confirm modal component, the options and the modal reference.
 * It also allows registering the TemplateRef containing the confirm modal component.
 *
 * It must be declared in the providers of the NgModule, but is not supposed to be used in application code
 */
@Injectable({
  providedIn: 'root',
})
export class ModalStateService {
  /**
   * The last options passed ConfirmService.confirm()
   */
  public options: ModalOptions;

  /**
   * The last opened confirmation modal
   */
  public modal: NgbModalRef;

  /**
   * The template containing the confirmation modal component
   */
  public template: any;
}
